
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Home, LayoutDashboard, LucideIcon } from "lucide-react";

type RouteConfig = {
  label: string;
  icon?: LucideIcon;
  showHome?: boolean;
};

const routes: Record<string, RouteConfig> = {
  "/": { label: "Vezérlőpult", icon: Home, showHome: false },
  "/funnels/": { label: "Oldal szerkesztő", icon: LayoutDashboard, showHome: true },
  "/settings": { label: "Beállítások", showHome: true },
};

export function AppBreadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const currentRoute = routes[location.pathname as keyof typeof routes];

  if (!currentRoute) return null;

  return (
    <div className="flex items-center justify-between mb-6">
    <Breadcrumb>
      <BreadcrumbList>
        {currentRoute.showHome && (
          <>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">
                  <Home className="h-4 w-4" />
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </>
        )}
        {pathnames.length > 0 ? (
          pathnames.map((path, index) => {
            const routePath = "/" + pathnames.slice(0, index + 1).join("/");
            const route = routes[routePath as keyof typeof routes];
            const isLast = index === pathnames.length - 1;

            if (!route) return null;

            return (
              <BreadcrumbItem key={path}>
                {isLast ? (
                  <BreadcrumbPage>{route.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={routePath}>{route.label}</Link>
                  </BreadcrumbLink>
                )}
                {!isLast && <BreadcrumbSeparator />}
              </BreadcrumbItem>
            );
          })
        ) : (
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-2">
              {currentRoute.icon && <currentRoute.icon className="h-4 w-4" />}
              {currentRoute.label}
            </BreadcrumbPage>
          </BreadcrumbItem>
        )}
      </BreadcrumbList>
    </Breadcrumb>
    </div>
  );
}
